import _ from 'underscore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import { loadingStates, savingStates } from 'bundles/discussions/constants';
import { hydrateQuestions } from 'bundles/discussions/utils/hydrateQuestionsAndAnswers';

class ThreadsStore extends BaseStore {
  static storeName = 'ThreadsStore';

  threads: Record<string, $TSFixMe> = {};

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'currentPage' implicitly has an 'any' type.
  currentPage;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'sort' implicitly has an 'any' type.
  sort;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'currentForumId' implicitly has an 'any' ty... Remove this comment to see the full error message
  currentForumId;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'forumType' implicitly has an 'any' type.
  forumType;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'forumId' implicitly has an 'any' type.
  forumId;

  loadingState = loadingStates.LOADING;

  savingStates = savingStates.UNCHANGED;

  filterQueryString = null;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'threadToInsert' implicitly has an 'any' ty... Remove this comment to see the full error message
  threadToInsert;

  // @ts-expect-error ts-migrate(7008) FIXME: Member 'userId' implicitly has an 'any' type.
  userId;

  hasLoaded() {
    return true;
  }

  getThreadsPage() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'answered' does not exist on type 'Thread... Remove this comment to see the full error message
    const filterCombinationKey = this.getFilterCombinationKey(this.sort, this.answered);
    return (
      // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
      (this.threads[this.filterQueryString] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId][filterCombinationKey] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId][filterCombinationKey][this.currentPage]) ||
      []
    );
  }

  getCurrentPageNum() {
    return this.currentPage;
  }

  getPageCount() {
    return (
      // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
      (this.threads[this.filterQueryString] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId].pageCount) ||
      0
    );
  }

  getThreadCount() {
    return (
      // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
      (this.threads[this.filterQueryString] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId] &&
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
        this.threads[this.filterQueryString][this.currentForumId].threadCount) ||
      0
    );
  }

  getLoadingState() {
    return this.loadingState;
  }

  getThreadCountForForum(filterQueryString: $TSFixMe, forumId: $TSFixMe) {
    return (
      this.threads[filterQueryString] &&
      this.threads[filterQueryString][forumId] &&
      this.threads[filterQueryString][forumId].threadCount
    );
  }

  hasLoadedThreadPage({ sort, answered, pageNum, currentForumId, filterQueryString }: $TSFixMe) {
    const filterCombinationKey = this.getFilterCombinationKey(sort, answered);
    return !!(
      this.threads[filterQueryString] &&
      this.threads[filterQueryString][currentForumId] &&
      this.threads[filterQueryString][currentForumId][filterCombinationKey] &&
      this.threads[filterQueryString][currentForumId][filterCombinationKey][pageNum]
    );
  }

  getFilterCombinationKey = (sort: $TSFixMe, filter: $TSFixMe) => {
    return sort + filter;
  };

  static handlers = {
    CLEAR_THREADS_CACHE() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.threads = {};
    },

    RECEIVE_THREADS({ results, sort, answered, pageNum, currentForumId, filterQueryString, forumType }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'getFilterCombinationKey' does not exist ... Remove this comment to see the full error message
      const incomingFilterCombinationKey = this.getFilterCombinationKey(sort, answered);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'getFilterCombinationKey' does not exist ... Remove this comment to see the full error message
      const existingFilterCombinationKey = this.getFilterCombinationKey(this.sort, this.answered);

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      if (!this.threads[filterQueryString]) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
        this.threads[filterQueryString] = {};
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      if (!this.threads[filterQueryString][currentForumId]) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
        this.threads[filterQueryString][currentForumId] = {};
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      if (!this.threads[filterQueryString][currentForumId][sort]) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
        this.threads[filterQueryString][currentForumId][incomingFilterCombinationKey] = {};
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.threads[filterQueryString][currentForumId][incomingFilterCombinationKey][pageNum] =
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
        hydrateQuestions(results);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.threads[filterQueryString][currentForumId].pageCount = Math.ceil(results.paging.total / 15);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.threads[filterQueryString][currentForumId].threadCount = results.paging.total;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingStates.DONE;

      // Insert the user's new thread, if it's not in the page from the backend
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
      if (this.threadToInsert) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
        const forumId = this.threadToInsert.forumId;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForumId' does not exist on type '... Remove this comment to see the full error message
        if (forumId === this.currentForumId) {
          const page =
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
            this.threads[this.filterQueryString][this.currentForumId][existingFilterCombinationKey][this.currentPage];
          const threadAlreadyPresent = _(page).findWhere({
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
            id: this.threadToInsert.id,
          });
          if (!threadAlreadyPresent) {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
            page.unshift(this.threadToInsert);
          }
        }
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
        this.threadToInsert = null;
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    START_THREADS_LOAD({ sort, answered, pageNum, filterQueryString, userId, forumType, forumId }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type '{ CLEAR_TH... Remove this comment to see the full error message
      this.sort = sort;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'answered' does not exist on type '{ CLEA... Remove this comment to see the full error message
      this.answered = answered;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentPage' does not exist on type '{ C... Remove this comment to see the full error message
      this.currentPage = pageNum;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForumId' does not exist on type '... Remove this comment to see the full error message
      this.currentForumId = forumId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type '{ CLE... Remove this comment to see the full error message
      this.forumType = forumType;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumId' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.forumId = forumId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type '{ CLEAR_... Remove this comment to see the full error message
      this.userId = userId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'filterQueryString' does not exist on typ... Remove this comment to see the full error message
      this.filterQueryString = filterQueryString;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    UPDATE_THREADS_LOADING_STATE(loadingState: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingState;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_ERROR() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type '{ ... Remove this comment to see the full error message
      this.loadingState = loadingStates.ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_SAVING() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.SAVING;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    RECEIVE_NEW_THREAD(newThread: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.SAVED;

      // force a reload of all thread pages
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threads' does not exist on type '{ CLEAR... Remove this comment to see the full error message
      this.threads = {};

      // Save for inserting when a new page of threads comes in
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadToInsert' does not exist on type '... Remove this comment to see the full error message
      this.threadToInsert = newThread;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_SAVE_ERROR() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_INVALID_TERM_ERROR() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.INVALID_TERM_ERROR;
      //this.savingState = savingStates.INVALID_TERM_ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_RATE_LIMIT_REACHED_ERROR() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.RATE_LIMIT_ERROR;
      //this.savingState = savingStates.RATE_LIMIT_ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },

    THREADS_API_USER_BLOCKED_ERROR() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type '{ C... Remove this comment to see the full error message
      this.savingState = savingStates.USER_BLOCKED_ERROR;
      //this.savingState = savingStates.USER_BLOCKED_ERROR;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ CL... Remove this comment to see the full error message
      this.emitChange();
    },
  };
}

export default ThreadsStore;
